import MainPage from "../pages/MainPage/Main";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard/Main";
import Transactions from "../pages/Transactions/Main";
import Signin from "../pages/Signin/Signin";
import Services from "../pages/Services/Main";
import ApiProviders from "../pages/APIProviders/Main";
import Users from "../pages/Users/Main";
import Alerts from "../pages/Alerts/Main";
import Administrators from "../pages/Administrators/Main";
import Security from "../pages/Security/Main";
import UserList from "../pages/Users/UserList";
import UserTabs from "../pages/Users/UserTabs";
import UserOverview from "../pages/Users/pages/UserOverview";
import UserCommissions from "../pages/Users/pages/UserCommissions";
import UserTransactions from "../pages/Users/pages/UserTransactions";
import IncomingRequests from "../pages/IncomingRequests/Main";
import Events from "../pages/Events/Main";
import EventVendors from "../pages/EventVendors/Main";
import { isAdmin, isVendor } from "../helpers/config";

const Root = () => {
  // Vendor-only routes
  const vendorRoutes = (
    <>
      <Route path="event-vendors" element={<EventVendors />} />
    </>
  );

  // Admin-only routes
  const adminOnlyRoutes = (
    <>
      <Route path="" element={<Navigate to="/dashboard/overview" />} />
      <Route path="overview" element={<Dashboard />} />

      <Route path="transactions" element={<Transactions />} />
      <Route path="events" element={<Events />} />
      <Route path="event-vendors" element={<EventVendors />} />
      <Route
        path="services/:slug?"
        element={<Services />}
        children={[
          <Route index path="" />,
          <Route path="*" element={<Services />} />
        ]}
      />
      <Route path="api-providers" element={<ApiProviders />} />
      <Route path="incoming-requests" element={<IncomingRequests />} />
      <Route
        path="users"
        element={<Users />}
        children={[
          <Route index path="" element={<UserList />} />,
          <Route
            element={<UserTabs />}
            children={[
              <Route path="overview" element={<UserOverview />} />,
              <Route path="commissions" element={<UserCommissions />} />,
              <Route path="transactions" element={<UserTransactions />} />
            ]}
          />
        ]}
      />
      <Route path="alerts" element={<Alerts />} />
      <Route path="administrators" element={<Administrators />} />
      <Route path="security" element={<Security />} />
      <Route path="*" element={<Navigate to="/dashboard/overview" replace />} />

    </>
  );

  return (
    <Routes>
      <Route path="/" element={<Navigate to={"/login"} />} />
      <Route path="/login" element={<Signin />} />
      <Route path="/dashboard" element={<MainPage />}>

        {/* Always show vendor routes */}
        {isVendor && vendorRoutes}

        {/* Show admin routes only if user is admin */}
        {isAdmin && adminOnlyRoutes}

      </Route>
    </Routes>
  );
};

export default Root;